import { render, staticRenderFns } from "./remark.vue?vue&type=template&id=011939e2&scoped=true"
import script from "./remark.vue?vue&type=script&lang=js"
export * from "./remark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011939e2",
  null
  
)

export default component.exports